import Task from './Task';
import ChangeUserLanguageTask from './ChangeUserLanguageTask';
import ChangeUserDataSyncWindowTask from './ChangeUserDataSyncWindowTask';
import CheckinCheckoutTask from './CheckinCheckoutTask';
import ClaimSaveTask from './ClaimSaveTask';
import ClaimWithdrawTask from './ClaimWithdrawTask';
import EventProductDataSaveTask from './EventProductDataSaveTask';
import RecapResponseSaveTask from './RecapResponseSaveTask';
import RemoveSecondaryClaimTask from './RemoveSecondaryClaimTask';
import PartialRecapResponseSaveTask from './PartialRecapResponseSaveTask';
import PartialClaimSaveTask from './PartialClaimSaveTask';
import PartialClaimDeleteTask from './PartialClaimDeleteTask';
import OpportunityInvitationResponseTask from './OpportunityInvitationResponseTask';
import PositionSaveTask from './PositionSaveTask';
import PositionUpdateTimesTask from './PositionUpdateTimesTask';

export const taskTypes = {
  Task,
  ChangeUserLanguageTask,
  ChangeUserDataSyncWindowTask,
  CheckinCheckoutTask,
  ClaimSaveTask,
  ClaimWithdrawTask,
  EventProductDataSaveTask,
  RecapResponseSaveTask,
  RemoveSecondaryClaimTask,
  PartialRecapResponseSaveTask,
  PartialClaimDeleteTask,
  PartialClaimSaveTask,
  OpportunityInvitationResponseTask,
  PositionSaveTask,
  PositionUpdateTimesTask,
};

export function taskClassForType(type) {
  if (type in taskTypes) {
    return taskTypes[type];
  }
  return null;
}
